import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import PrestamoCuota from './PrestamoCuota'
import history from "../login/history";
import { SolicitudesDetalle } from "./SolicitudesDetalle";

const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

export default class SolicitudesPrestamos extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  getColumn() {
    return [
      {
        name: "N° de Contraseña",
        selector: row => row.numeroContrasena

      },
      {
        name: "Fecha de Contraseña",
        selector: row => row.fechaContrasena

      },
      {
        name: "Monto",
        selector: row => row.montoSolicitado

      },
      {
        name: "Solicitud",
        selector: row => row.solicitud,

      },
      {
        name: "Sucursal ",
        selector: row => row.sucursal,

      },
      {
        name: "Fecha de Solicitud",
        selector: row => row.fechaSolicitud

      },
      {
        name: "Oficial ",
        selector: row => row.oficial
      },
    ];
  }

  

  render() {
    return (
      <DataTable
        noHeader={true}
        pagination={false}
        columns={this.getColumn()}
        // TODO descomentar al terminar pruebas
        // data={this.props.prestamos}
        data={this.props.prestamos}
        noDataComponent="no hay registros para mostrar"
        responsive={true}
        striped={true}
        pointerOnHover
        expandableRows
        expandableRowsComponent={SolicitudesDetalle}
      />
    );
  }
}